import React from 'react'
import proff from "../img/niceage0.jpg";
import proft from "../img/niceage1.jpg"
import nice from "../img/niceage.jpg";

export default function Niceage() {
  return (
    <div>
    {/* <main className="page-wrapper"> */}
        {/* <section className="container pt-5 pb-lg-2 pb-xl-4 py-xxl-5 my-5"> <br/> */}
       

        <section className="bg-primary position-relative py-5"> <br/>
        <div className="d-none d-dark-mode-block position-absolute top-0 start-0 w-100 h-100" ></div>
        <div className="container dark-mode position-relative zindex-2 py-5 mb-4 mb-sm-5">
        <div className="d-lg-flex position-relative h-100" style={{ position: "relative" }}>
          <a className="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 p-0 mt-3 me-3 mt-sm-4 me-sm-4" href="/" data-bs-toggle="tooltip" data-bs-placement="left" title="Back to home"><i className="ai-home"></i></a>
        </div>
          <div className="row pb-5 mb-2 mb-sm-0 mb-lg-3">
            <div className="">
              <h1 className="display-4 pb-2 pb-sm-3">Клуб «Приятный возраст» (55+)</h1>
              <p className='display-6'>В нашем центре уделяют особое внимание нашим родителям, бабушкам и дедушкам. Благодаря их воспитанию мы формировались и становились как личности.</p>
              <ul className="list-unstyled d-flex flex-wrap mb-0">
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Тренировка памяти</li>
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Восполняет обшение</li>
                {/* <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Взаимапомощь</li> */}
                <li className="d-flex py-1 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Помогает почувстовать себя важным</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* About*/}
      <section className="container position-relative zindex-3" style={{marginTop: '-135px'}}>
        <div className="rounded-5 overflow-hidden"> 
          <div className="jarallax ratio ratio-16x9" datajarallax dataspeed="0.6">
            <div className="jarallax-img" style={{backgroundImage: 'url(assets/img/landing/corporate/niceage.jpg)'}}></div>
          </div>
        </div>
        <div className="container row pt-5 mt-n2 mt-sm-0 mt-md-2 mt-lg-4 mt-xl-5 ">
          <div className="col-md-6 col-lg-5 m-4">
            <div className="fs-sm text-uppercase mb-3">Как приятно!</div>
            <h2 className="mb-lg-4">«Пока у нас есть родители, мы чувствуем себя детьми», а это бесценно.</h2>
            <br/>
            <div className="mb-4">
                    <img className="rounded-5" src={proff} alt="Ima"/>
                    <p></p>
                    <br/>
                    <p></p>
                    <img className="rounded-5" src={proft} alt="Ima"/>
            </div>
          </div>
          <div className="container col-md-7 col-xl-6 pt-1 pt-sm-2 pt-md-5">
            <p className="fs-xl">Специально для наших родных мы создали мероприятия и открыли направление <strong>«Приятный возраст»</strong> , направленные на развитие творческих способностей, поддержание памяти и общение, которые, несомненно, способствуют улучшению качества жизни, обогащению жизненного опыта и укреплению социальных связей.</p>
            <p className="fs-xl"> <strong>В данном клубе у нас организованы:</strong></p>
            <ol className="fs-xl mb-0">
            <li> <strong>Тематические встречи: </strong> Организация встреч, посвященных определенным темам, таким как путешествия, развитие навыков рисования и визуализации воображения, нейрографика, кулинария или искусство, а также возможность поделиться рассказами и историями из жизни, делиться воспоминаниями.</li>
            <li> <strong>Групповые проекты: </strong> Совместное создание проектов, например, оформление фотокниги воспоминаний или подготовка театральной постановки, может способствовать развитию чувства общности и сотрудничества.</li>
            <li> <strong>Мастер-классы по здоровью: </strong> Проведение занятий по йоге, дыхательным практикам и другим видам физической активности, адаптированным для пожилых людей - полезно для поддержания физического здоровья.</li>
            <li> <strong>Интерактивные игры: </strong> Включение интерактивных игр, таких как викторины или квесты делают встречи более динамичными и увлекательными.</li>
            <li> <strong>Семейные дни: </strong> Периодическое проведение мероприятий, где участники могут пригласить своих детей и внуков, укрепляют семейные связи и создают атмосферу единства поколений.</li>
            <li> <strong>Онлайн-встречи: </strong> В условиях пандемии или для тех, кто не может посещать клуб лично, организация онлайн-встреч через платформы идеоконференций – это наше отличное дополнение.</li>
            </ol> 
              <br/>
              <p></p>
               <div className="">
                <img className="rounded-5" src={nice} alt="Ima"/>  
               </div>
          </div>
        </div>
      </section>
      {/* Approach*/}
      <section className="container">
        <div className="pt-2 pt-sm-4 pt-lg-5 mt-xxl-2">
          <div className="fs-sm text-uppercase mb-3">Как проходят мероприятия</div>
          <h3 className=" mb-lg-4">Мероприятия проводятся днем каждую среду. <br/> Расписание по мастер-классам необходимо уточнять у администратора. 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://t.me/formatyou72"><i className="ai-telegram text-success"> </i> </a>
          <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://www.instagram.com/developskillsnow"><i className="ai-instagram text-warning"> </i> </a> 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/thormayou"><i className="ai-vk text-danger"> </i> </a> 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/developskillsnow"><i className="ai-vk text-primary"> </i> </a> 
          </h3>
          <p className="fs-lg">
            Для первого посещения необходима предварительная запись по телефону: +7 (992) 300-65-23, +7 (992) 300-65-46 <br/>
            Внимание! Рекомендуем добавиться в группу Telegram «Приятный возраст», чтобы максимально быстро получать новую информацию о работе Клуба и своевременно записываться на мероприятия.
            </p>
          <div>
           <h4 className="">Ждем вас на наших мероприятиях! <br/> С собой иметь хорошее настроение и желание прекрасно провести время!</h4>
          <br/>
          </div>
        </div>
      </section>
    </div>
  )
}
